import { ApiResult, EventClipInfo, getAnonymous, IEventClipInfo } from "@app/shared";

/**
 * The clip behind an emailed link: its status, plus signed video/photo URLs once the unit has
 * uploaded. Resolved by the clip's own token through the public clip-info endpoint, anonymously —
 * the viewer holding the link has no session, and needs none.
 *
 * Do not switch this back to the generated `EventClips.getClipInfo`. That client sends credentials,
 * and the public endpoint answers with a wildcard Access-Control-Allow-Origin, which browsers refuse
 * on a credentialed request. From app.omnisightusa.com that meant every emailed clip link showed
 * "We couldn't load this clip" against a server that had answered 200.
 */
export function getPublicClipInfo(token?: string): ApiResult<EventClipInfo> {
    const query = token !== undefined ? `?token=${encodeURIComponent(token)}` : "";
    return getAnonymous<IEventClipInfo>(`/api/events/clip-info${query}`).then((result) =>
        result === undefined ? undefined : new EventClipInfo(result),
    );
}
